import la_LA from './la_LA.json';
/* PLOP_INJECT_IMPORT */

export default {
  ...la_LA,
  /* PLOP_INJECT_EXPORT */
};
